'use client';

import { Toaster as Sonner, ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--color-bg-default)',
          '--normal-text': 'var(--color-fg-default)',
          '--normal-border': 'var(--color-border-default)'
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
